import { render, staticRenderFns } from "./huotiStatisticsItem.vue?vue&type=template&id=3a459ae6&scoped=true&"
import script from "./huotiStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./huotiStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./huotiStatisticsItem.vue?vue&type=style&index=0&id=3a459ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a459ae6",
  null
  
)

export default component.exports